import { PeriodSelectorOptionWithDates } from '../models/components/ChartStore';

export default function isChartPeriodSelected(
    period: PeriodSelectorOptionWithDates,
    startDate?: string,
    endDate?: string
) {
    if (startDate && endDate) {
        return period.startDate === startDate && period.endDate === endDate;
    }
    return period.selected;
}



// WEBPACK FOOTER //
// ./src/utils/isChartPeriodSelected.ts